import * as Yup from 'yup';
import { AdminAllowanceNames, AllowancesNames, ContractTypes } from '@pharmaplan/common';
import { allowanceValidator, commonAllowanceValidations, hourlyRateValidator } from '../../../helpers/commonValidators';

export const SelfApproveValidator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    [AdminAllowanceNames.pharmacistHourlyRate]: Yup.number().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
  });

const Validator = () =>
  Yup.object().shape({
    [AdminAllowanceNames.mealAllowance]: allowanceValidator(),
    [AdminAllowanceNames.accommodationAllowance]: allowanceValidator(),
    [AdminAllowanceNames.travelAllowance]: allowanceValidator(),

    [AdminAllowanceNames.pharmacistHourlyRate]: hourlyRateValidator(),
    [AdminAllowanceNames.pharmacyHourlyRate]: hourlyRateValidator(),
    [AllowancesNames.emergencyFees]: allowanceValidator(),
  });

export default Validator;
